import React, { useEffect, useRef, useState } from 'react';
import gsap from 'gsap';

const CustomCursor = () => {
  const dotRef = useRef(null);
  const ringRef = useRef(null);
  const [isHovering, setIsHovering] = useState(false);

  useEffect(() => {
    document.documentElement.classList.add('hide-native-cursor');

    // Dot tracks exactly
    const dotX = gsap.quickTo(dotRef.current, 'x', { duration: 0.05, ease: 'power3' });
    const dotY = gsap.quickTo(dotRef.current, 'y', { duration: 0.05, ease: 'power3' });

    // Ring trails slightly behind
    const ringX = gsap.quickTo(ringRef.current, 'x', { duration: 0.25, ease: 'power3.out' });
    const ringY = gsap.quickTo(ringRef.current, 'y', { duration: 0.25, ease: 'power3.out' });

    const moveCursor = (e) => {
      dotX(e.clientX);
      dotY(e.clientY);
      ringX(e.clientX);
      ringY(e.clientY);
    };

    const handleMouseOver = (e) => {
      if (
        e.target.tagName.toLowerCase() === 'button' ||
        e.target.tagName.toLowerCase() === 'a' ||
        e.target.closest('button') ||
        e.target.closest('a') ||
        e.target.closest('[data-cursor="hover"]')
      ) {
        setIsHovering(true);
      } else {
        setIsHovering(false);
      }
    };

    window.addEventListener('mousemove', moveCursor);
    window.addEventListener('mouseover', handleMouseOver);

    return () => {
      document.documentElement.classList.remove('hide-native-cursor');
      window.removeEventListener('mousemove', moveCursor);
      window.removeEventListener('mouseover', handleMouseOver);
    };
  }, []);

  return (
    <>
      <style>{`
        @media (min-width: 1024px) {
          .hide-native-cursor * {
            cursor: none !important;
          }
        }
      `}</style>
      
      {/* Outer Trailing Ring */}
      <div
        ref={ringRef}
        className="pointer-events-none fixed top-0 left-0 z-[99998] hidden lg:flex items-center justify-center transform -translate-x-1/2 -translate-y-1/2"
      >
        <div
          className={`rounded-full border-2 border-cyan-500/50 transition-all duration-300 ease-out ${
            isHovering ? 'w-14 h-14 bg-cyan-500/10 scale-110' : 'w-8 h-8'
          }`}
        ></div>
      </div>

      {/* Inner Dot */}
      <div
        ref={dotRef}
        className="pointer-events-none fixed top-0 left-0 z-[99999] hidden lg:flex items-center justify-center transform -translate-x-1/2 -translate-y-1/2"
      >
        <div
          className={`w-2 h-2 rounded-full bg-cyan-500 transition-all duration-300 ${
            isHovering ? 'opacity-0 scale-0' : 'opacity-100 scale-100'
          }`}
        ></div>
      </div>
    </>
  );
};

export default CustomCursor;
